<template>
  <!-- 预览文件页面 -->
  <preview-gbq5 v-if="isGbq5" :suffix="suffix" :query="query" :preview-share="previewShare"></preview-gbq5>
  <others-modle v-else-if="isOthers" :query="query"></others-modle>

  <iframe v-else class="preview_iframe" :src="iframeSrc"></iframe>
</template>
<script>
import PreviewGbq5 from '@/components/preview/PreviewGbq5'
import OthersModle from '@/components/preview/OthersModle'
import { capitalize } from '@/assets/utils'
import { getCookie } from '@/assets/utils/CommonUtil'
export default {
  name: 'Preview',
  computed: {
    query () {
      const obj = this.$route.query
      // if ('path' in obj) {
      //   obj.path = decodeURIComponent(obj.path)
      // }
      return obj
    },
    // 是否预览 分享的文件
    previewShare () {
      return (
        !this.query.path &&
        'shareToken' in this.query &&
        this.query.shareToken !== ''
      )
    },
    fileName () {
      let fileName = ''
      if (this.previewShare) {
        fileName = this.query.fileName
      } else {
        if ('fileName' in this.query) {
          fileName = this.query.fileName
        } else if ('path' in this.query) {
          fileName = this.query.path
        }
      }
      return fileName
    },
    suffix () {
      // 计价工程、结算工程、验工工程、审核工程、概算工程
      const reg = /\.(gbq5|gsc5|gpv5|gsh5|gpb5|gbq6|gsc6|gpv6|gsh6|gpb6|gbq7|gsc7|gpv7|gsh7|gpb7)$/i
      const arr = reg.exec(this.fileName)
      if (arr && arr.length > 1) {
        return capitalize(arr[1], true, true)
      } else {
        return capitalize(
          this.fileName.substring(this.fileName.lastIndexOf('.') + 1),
          true,
          true
        )
      }
    },
    // 是否预览的GBQ5 文件
    isGbq5 () {
      const arr = ['gbq5', 'gsc5', 'gpv5', 'gsh5', 'gpb5', 'gbq6', 'gsc6', 'gpv6', 'gsh6', 'gpb6','gbq7', 'gsc7', 'gpv7', 'gsh7', 'gpb7', '', 'gpb6jy', 'gpb6xs', 'gbq6jy', 'gbq6xs', 'gpv6jy', 'gpv6xs', 'gsc6jy', 'gsc6xs', 'gsh6jy', 'gsh6xs']
      return arr.includes(this.suffix)
      // return (
      //   this.suffix === 'gbq5' ||
      //   this.suffix === 'gsc5' ||
      //   this.suffix === 'gpv5' ||
      //   this.suffix === 'gsh5' ||
      //   this.suffix === 'gpb5' ||
      //   this.suffix === 'gbq6' ||
      //   this.suffix === 'gsc6' ||
      //   this.suffix === 'gpv6' ||
      //   this.suffix === 'gsh6' ||
      //   this.suffix === 'gpb6'
      // )
    },
    isOthers () {
      const arr = [
        'igms',
        'e5d',
        'rvt',
        'rfa',
        'gmp',
        'cadi2',
        'fbx',
        'dwf',
        'nwd',
        'rte',
        'skp',
        'nwc',
        'ifc',
        'dxf',
        '3dm',
        'stl',
        'dgn',
        'stp',
        'step',
        'rvm',
        'osgb',
        '3ds',
        'obj',
        'dae',
        'ply',
        'gcl10',
        'ggj12'
      ]
      return arr.indexOf(this.suffix) !== -1
    },
    iframeSrc () {
      let src = ''
      if (this.query.previewUrl) {
        src = 'https://ow365.cn/?i=17922&ssl=1&furl=' + encodeURIComponent(this.query.previewUrl)
        // 解决 IE 浏览器不能正常浏览 文件名称超长的 office文件的问题 将文件名称放到cookie中
        if (this.$route.query.previewFileName) {
          const previewFileName = getCookie(this.$route.query.previewFileName)
          if (previewFileName) {
            src += encodeURIComponent('filename="' + previewFileName + '"')
          }
        }
      }
      return src
    }
  },
  created () {},
  mounted () {
    setTimeout(() => {
      console.dir(this.$route)
      console.dir(this.iframeSrc)
      console.dir('1111111111111')
    }, 1000)
    window.name = this.query.windowName || 'target'
  },
  components: {
    PreviewGbq5,
    OthersModle
  }
}
</script>
<style lang="less" type="text/less">
.preview_iframe {
  width: 100%;
  height: 99.5%;
  box-sizing: border-box;
}
</style>
